import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
// import styled from "styled-components";
import { StoryblokComponent } from '@sb-konzept/gatsby-source-storyblok'
import BannerImage from 'components/BannerImage'
import DojoHomeBlock from 'components/DojoHomeBlock'
import Navbar from 'components/DojoNavbar'
import Link from 'components/Link'
import PageLayout from 'components/PageLayout'
// import AktionBanner from "components/AktionBanner";
import ProbetrainingBanner from 'components/ProbetrainingBanner'
import RemarkRenderer from 'components/RemarkRenderer'
import Separator from 'components/Separator'
import React from 'react'
// import Badge from "components/Badge";

const useStyles = makeStyles({
  uppercase: {
    textTransform: 'uppercase'
  },
  buttonLink: {
    display: 'block',
    textDecoration: 'none',
    fontWeight: 700
  }
})

export default function DojoHomepage(props) {
  const { siteInfo, content } = props
  const {
    willkommenText,
    leader,
    trainers,
    news,
    bannerImage,
    bannerImageAltText,
    bannerText,
    bannerButton,
    bannerButtonAction,
    contactForm
  } = content
  const classes = useStyles()

  return (
    <PageLayout>
      <Box bgcolor="background" pb={2}>
        <Box pb={2} pt={5}>
          <Separator />
        </Box>

        <Box
          bgcolor="#212121"
          height="auto"
          id="home"
          ml={{ xs: 0, md: '10vw' }}
          mr={{ xs: 0, md: '10vw' }}
          my="3vh"
        >
          <Navbar />
        </Box>

        <DojoHomeBlock
          leader={leader}
          news={news}
          siteInfo={siteInfo}
          trainers={trainers}
          willkommenText={willkommenText}
        />

        <Box
          display="flex"
          flexDirection="column"
          mx={{ xs: '0vw', md: '10vw' }}
          my={6}
        >
          <Box display="flex" flexWrap="wrap">
            {!!bannerText && !!bannerText.childMarkdownRemark && (
              // NOTE: sometimes the banner doesn't disappear if the rich text is empty but is still formatted;
              // fix by changing formatting of empty rich text to paragraph, or to heading and then paragraph
              <Box
                alignItems="center"
                bgcolor="text.primary"
                color="primary.main"
                display="flex"
                flex="5 1 75%"
                justifyContent="flex-start"
                px={2}
                py={1}
              >
                <RemarkRenderer
                  editable
                  ast={bannerText.childMarkdownRemark?.htmlAst}
                />
              </Box>
            )}
            {!!bannerButton && (
              <Box
                alignItems="center"
                bgcolor="primary.main"
                display="flex"
                flex="1 5 25%"
                justifyContent="center"
                px={2}
                py={1}
                width="max-content"
              >
                <Box
                  className={classes.buttonLink}
                  color="text.primary"
                  component={Link}
                  link={bannerButtonAction}
                  textAlign="center"
                >
                  <Typography variant="h3">{bannerButton}</Typography>
                </Box>
              </Box>
            )}
            {/* <Badge /> */}
          </Box>
          <BannerImage
            alt={bannerImageAltText || 'image'}
            bannerImage={bannerImage}
          />
        </Box>
      </Box>

      <Box bgcolor="secondary">
        <Box>
          <ProbetrainingBanner />
        </Box>

        {contactForm && (
          <Box maxWidth={750} mx="auto" my={5} px="4.165vw">
            <StoryblokComponent content={contactForm[0]} />
          </Box>
        )}
      </Box>
    </PageLayout>
  )
}
